import React, { useEffect, useState } from "react";
import { Grid, Avatar, Backdrop, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import moment from "moment";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import axios from "../../../../Uri";
import GuestPopUp from "../GuestPopUp/guestPopUP";
import "./buildingLayout.css";
import Tooltip from "@material-ui/core/Tooltip";
import { ToastContainer, toast } from "react-toastify";
//redux imports
import { useSelector, useDispatch } from "react-redux";
import { getBedsByBuildingId, makeFalse } from "../../../../redux/actions/RatActions";
import { getTotalAmountPaidByGuest } from "../../../../redux/actions/GuestActions";
let GuestDetails = {};
let GuestDueAmount = null;
let TotalAmountByGuest = null;
let GuestId = null;
const BuildingsLayout = (props) => {
  const dispatch = useDispatch();
 
  TotalAmountByGuest = useSelector((state) => state.GuestInfo.totalAmountPaid);
  const loading = useSelector((state) => state.buildings.loading);
  const totalAmountPaidByGuest = () => {
    dispatch(getTotalAmountPaidByGuest(GuestId));
  };
  useEffect(() => {
    dispatch(getBedsByBuildingId(props.buildingId));
  }, []);
  const buildingInfo = useSelector((state) => state.buildings.bedsByBuilding);
  const [open, setOpen] = React.useState(false);
  const handleCloseGuestModalWindow = () => {
    dispatch(makeFalse())
    setOpen(false);
  }
  const changeBedStatus = useSelector((state) => state.buildings.changeBedStatus);
  const editDue = useSelector((state)=>state.buildings.editDue)
  const forceCheck = useSelector((state)=>state.buildings.forceCheck)
  const cancelCheckOut = useSelector((state)=>state.buildings.cancelCheckouts)
  {changeBedStatus === true ? (toast.success("Bed Changed Successfully"),dispatch(makeFalse())):""}
  {editDue === true ? (toast.success("Due Amount Updated SuccessFully"),dispatch(makeFalse())):''}
  {forceCheck === true ? (toast.success("Guest CheckOuted SuccessFully"),dispatch(makeFalse())):''}
  {cancelCheckOut === true ? (toast.success("Cancel Checkout Successfull"),dispatch(makeFalse())):""}
  return (
    <>
      <MDBox padding="30px" sx={{ border: 3 }}>
        {loading ? (
          buildingInfo.map((post) => {
            return (
              <>
                <GuestPopUp
                  open={open}
                  handleCloseGuestModalWindow={handleCloseGuestModalWindow}
                  GuestDetails={GuestDetails}
                  GuestDueAmount={GuestDueAmount}
                  TotalAmountByGuest={TotalAmountByGuest}
                />
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {" "}
                    <h4 className="buildingColor" key={post.buildingName}>
                      {post.buildingName}
                    </h4>{" "}
                  </Grid>
                  {post.floors.map((item) => {
                    return (
                      <>
                        <Grid item lg={12} xs={12}>
                          {" "}
                          <h6
                            className="floorColor"
                            key={item.floorName}
                            align="center"
                          >
                            {item.floorName}
                          </h6>
                        </Grid>
                        {item.rooms.map((rmno) => {
                          return (
                            <>
                              <Grid item lg={3} md={6} xs={12}>
                                <Grid
                                  spacing={1}
                                  container
                                  rowSpacing={1}
                                  sx={{ border: 1, pl: 1 }}
                                >
                                  <Grid>
                                    <h5
                                      className="roomColor "
                                      key={rmno.roomNumber}
                                    >
                                      {rmno.roomNumber}
                                    </h5>
                                  </Grid>
                                  {rmno.beds.map((bdno) => {
                                    return (
                                      <>
                                        <Grid item xs>
                                          <Grid container rowSpacing={1}>
                                            <Grid item xs={12} align="center">
                                              {(() => {
                                                if (bdno.bedStatus === true) {
                                                  return (
                                                    <>
                                                      <HotelOutlinedIcon
                                                        key={bdno.bedId}
                                                        className="click"
                                                        color="success"
                                                      />
                                                    </>
                                                  );
                                                } else {
                                                  return (
                                                    <Tooltip
                                                      title={bdno.guestName}
                                                    >
                                                      <Avatar
                                                        className="click"
                                                        src={`https://sreelakshmiheavenshostels.co.in/api/guest/getImage/${bdno.guestId}`}
                                                        height={45}
                                                        width={45}
                                                        onClick={async () => {
                                                          // setLoading(false);
                                                          GuestId =
                                                            bdno.guestId;
                                                          totalAmountPaidByGuest();
                                                          GuestDueAmount =
                                                            bdno.dueAmount;
                                                          await axios
                                                            .get(
                                                              `/guest/getGuestByGuestId/${bdno.guestId}`
                                                            )
                                                            .then((res) => {
                                                              GuestDetails =
                                                                res.data;
                                                              setOpen(true);
                                                              // setLoading(true);
                                                            })
                                                            .catch((err) => {
                                                              toast.error(
                                                                "Something went wrong"
                                                              );
                                                            });
                                                        }}
                                                      />
                                                    </Tooltip>
                                                  );
                                                }
                                              })()}
                                            </Grid>
                                            <Grid item xs={12} align="center">
                                              {(() => {
                                                if (
                                                  bdno.guestStatus == "InNotice"
                                                ) {
                                                  return (
                                                    <h5
                                                      className="inNoticeText"
                                                      align="center"
                                                      key={bdno.bedName}
                                                    >
                                                      {bdno.bedName}
                                                    </h5>
                                                  );
                                                } else if (
                                                  bdno.bedStatus === true
                                                ) {
                                                  return (
                                                    <h5
                                                      className="availableBedText"
                                                      align="center"
                                                      key={bdno.bedName}
                                                    >
                                                      {bdno.bedName}
                                                    </h5>
                                                  );
                                                } else if (bdno.dueAmount > 0) {
                                                  return (
                                                    <h5
                                                      className="dueGuestsText"
                                                      align="center"
                                                      key={bdno.bedName}
                                                    >
                                                      {bdno.bedName}
                                                    </h5>
                                                  );
                                                } 
                                                else if (
                                                  bdno.plannedCheckOutDate <=
                                                  moment(new Date()).format() && bdno.exceeded === true
                                                ) {
                                                  return (
                                                    <h5
                                                      className="exceedGuestText"
                                                      align="center"
                                                      key={bdno.bedName}
                                                    >
                                                      {bdno.bedName}
                                                    </h5>
                                                  );
                                                } 
                                                else if(bdno.dueAmount <= 0) {
                                                  return (
                                                    <h5
                                                      className="activeGuestsText"
                                                      align="center"
                                                      key={bdno.bedName}
                                                    >
                                                      {bdno.bedName}
                                                    </h5>
                                                  );
                                                }
                                                else{
                                                  return null;
                                                }
                                              })()}
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </>
                                    );
                                  })}
                                </Grid>
                              </Grid>
                            </>
                          );
                        })}
                      </>
                    );
                  })}
                </Grid>
              </>
            );
          })
        ) : (
          // "loading...."
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
            // onClick={closeLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </MDBox>
      <ToastContainer
        position="top-right"
        min-width="2%"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};
export default BuildingsLayout;
